import type { DateOnly } from '@atlassian/jira-platform-utils-date-only';
import type { FullCalendarItemInput, ConnectedProject } from '../../types';

export type StateType = {
	releases: FullCalendarItemInput[];
	isLoading: boolean;
	error: Error | null;
	connectedProjects: ConnectedProject[];
};

export type CalendarReleasesInput = {
	releaseDateBefore: DateOnly;
	releaseDateAfter: DateOnly;
};

export type CalendarReleasesInternalProps = CalendarReleasesInput & {
	projectId: string;
	releasesDataDispatch: React.Dispatch<ActionType>;
};

export const PROJECTS_LOADED_ACTION = 'projects_loaded';
export const FETCHING_RELEASES_ACTION = 'fetching_releases';
export const RELEASES_LOADED_ACTION = 'releases_loaded';
export const ERROR_ACTION = 'error';

export type ActionType =
	| { type: typeof PROJECTS_LOADED_ACTION; connectedProjects: ConnectedProject[] }
	| { type: typeof FETCHING_RELEASES_ACTION; connectedProjects: ConnectedProject[] }
	| { type: typeof RELEASES_LOADED_ACTION; releases: FullCalendarItemInput[] }
	| { type: typeof ERROR_ACTION; error: Error };
